import { render, staticRenderFns } from "./ProposalPage.vue?vue&type=template&id=e6b12cd4&scoped=true&"
import script from "./ProposalPage.vue?vue&type=script&lang=js&"
export * from "./ProposalPage.vue?vue&type=script&lang=js&"
import style0 from "./ProposalPage.vue?vue&type=style&index=0&id=e6b12cd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b12cd4",
  null
  
)

export default component.exports